import { render, staticRenderFns } from "./InappropriateBehaviourClassroomActionItem.vue?vue&type=template&id=930784a8&"
import script from "./InappropriateBehaviourClassroomActionItem.vue?vue&type=script&lang=js&"
export * from "./InappropriateBehaviourClassroomActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports